import React from "react";
import { AnchorMenu } from "../../components/anchor-menu";
import { Overview } from "./sections/overview";
import { Solution } from "./sections/solution";
import { Impact } from "./sections/impact";
import { ReadMore } from "../../components/read-more";

export enum HomeAnchor {
    OVERVIEW = "overview",
    SOLUTION = "solution",
    IMPACT = "impact",
    BENEFITS = "benefits"
}

export interface IHomeProps {
    currAnchor: string;
    showAnchorMenu: boolean;
    handleMenuClick: (anchor: string) => void;
    handleNavClick: (anchor: string) => void;
    onComponentMounted: (anchorList: string[]) => void;
}

export class Home extends React.Component<IHomeProps> {
    public static readonly ANCHOR_LIST: string [] = [
        HomeAnchor.OVERVIEW,
        HomeAnchor.SOLUTION,
        HomeAnchor.IMPACT
    ]
    
    componentDidMount() {
        this.props.onComponentMounted(Home.ANCHOR_LIST.slice());
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.showAnchorMenu
                        ? <AnchorMenu
                            selectedAnchor={this.props.currAnchor || HomeAnchor.OVERVIEW}
                            handleMenuClick={this.props.handleMenuClick}
                            anchorList={Home.ANCHOR_LIST.slice()}
                        />
                        : undefined
                }
                <main>
                    <article>
                        <Overview 
                            sectionId={HomeAnchor.OVERVIEW}
                            index={Home.ANCHOR_LIST.indexOf(HomeAnchor.OVERVIEW)}
                        />
                        <Solution 
                            sectionId={HomeAnchor.SOLUTION}
                            index={Home.ANCHOR_LIST.indexOf(HomeAnchor.SOLUTION)}
                        />
                        <Impact 
                            sectionId={HomeAnchor.IMPACT}
                            index={Home.ANCHOR_LIST.indexOf(HomeAnchor.IMPACT)}
                        />
                        <ReadMore
                            onNav={this.props.handleNavClick}
                            links={
                                [
                                    {
                                        cta: "Learn About the Design Process",
                                        url: "/design"
                                    },
                                    {
                                        cta: "Learn About the Research Process",
                                        url: "/research"
                                    }
                                ]
                            }
                        />
                    </article>
                </main>
            </React.Fragment>
        );
    }
}